module.exports = __webpack_public_path__ + "img/INSIGHTS (5).191705b3.png";